import { Icon } from '@blueprintjs/core';
import PropTypes from 'prop-types';

const ErrorMessage = ({
  message,
  useTriangleIcon = false,
  large = false,
  small = false,
  style = {},
  invertedColors = false,
}) => {
  return (
    message && (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          color: invertedColors ? 'white' : 'var(--site-warning-color)',
          ...(invertedColors && {
            backgroundColor: 'var(--site-warning-color)',
            padding: '2px 6px',
          }),
          ...{ fontSize: large ? 'large' : small ? 'small' : 'medium' },
          lineHeight: 'normal',
          fontFamily: 'Montserrat',
          fontWeight: 500,
          ...style,
        }}>
        <Icon
          style={{ marginRight: 8 }}
          icon={useTriangleIcon ? 'warning-sign' : 'error'}
          size={large ? 24 : small ? 16 : 20}
        />
        {message}
      </div>
    )
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  useTriangleIcon: PropTypes.bool,
  large: PropTypes.bool,
  small: PropTypes.bool,
  style: PropTypes.object,
  invertedColors: PropTypes.bool,
};

export default ErrorMessage;
